const ua = require('./module/_ua.js');
const FnTop = require('./_top.js');
const topNews = require('./_top_news.js');
const topNewsSlider = require('./_top_news_slider.js');
const TopMainvisual = require('./_top_mainvisual.js');
const topMainvisualEffect = require('./_top_mainvisual_effect.js');
const serviceIndex = require('./_service_index.js');
const fnNews = require('./_news.js');
const runInview = require('./module/_jquery.invew.js');
const headerScroll = require('./module/_header_scroll.js');
const formCtr = require('./_form.js');
const setWrapMargin = require('./module/_wrap_margin.js');
const runWoookmark = require('./module/_wookmark.js');
const setBtnPageTop = require('./module/_btn_pagetop.js');
const initMap = require('./_access.js');



const Pjax = {

	init: function(){
		var that = this;
		if((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') == 'top' || $('body')[0].getAttribute('data-category') == 'access')){
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=device-width, initial-scale=1.0')
		}

		that.setObj();
		that.$window.on('load', function(e){
			that.onLoad();
			setTimeout(function(){
				$('.loading').addClass('is--hide');
			},500);
			setTimeout(function(){
				runInview();
			},500);
		});
		that.$window.on('load resize', function(e){
			new TopMainvisual();
		});
		that.$document.on('click', '.link--scroll',function(e){
			e.preventDefault();
			$( 'html,body' ).animate( { scrollTop: $( $( this ).attr( 'href' ) ).offset().top - 102 }, 'swing' );
		});
		that.$document.on('click', '.link--pjax',function(e){
			sessionStorage.entrance = 'is--hide';
			$('.entrance').addClass('is--hide--r');
			$('.menu-trigger').removeClass('is--active');
			$('.gnav').removeClass('is--active');
			$('.header .title').removeClass('is--active');
			that.onClick(e,this, 0);
		});
		that.$document.on('click', '.link--pjax--snav',function(e){
			that.onClick(e,this, 374);
			$('.header').addClass('is--scroll');
		});
		that.$document.on('click', '.link--pjax--pagenav',function(e){
			that.onClick(e,this, 374);
			$('.header').addClass('is--scroll');
		});
		that.$document.on('click', '.link--pjax--work--localize',function(e){
			that.onClick(e,this, 1230);
		});
		that.$document.on('click', '.link--pjax--work--illust',function(e){
			that.onClick(e,this, 1510);
		});
		that.$document.on('click', '.link--pjax--work--promo',function(e){
			that.onClick(e,this, 1240);
		});
		that.$window.on('popstate', function(e) {
			that.onPopState(e);
		});
	},
	setObj: function() {
		this.$window = $(window);
		this.$document = $(document);
		this.$link_pjax = $('.link--pjax');
		this.$wrap = $('.wrap');
		this.$container = $('.container');
	},
	onLoad: function(){
		var current = this.getCurrentPath().split('/');
		current = current[current.length - 1];

		history.replaceState(this.pushStateObj(current), current.split('.')[0], null);

		if(ua('iphone')){
			$(document).on('click', '.menu-trigger', function(e){
				e.preventDefault();
				$(this).toggleClass('is--active');
				$('.gnav').toggleClass('is--active');
				$('.header .title').toggleClass('is--active');
			});
		}else if(ua('android')){
			$(document).on('click', '.menu-trigger', function(e){
				e.preventDefault();
				$(this).toggleClass('is--active');
				$('.gnav').toggleClass('is--active');
				$('.header .title').toggleClass('is--active');
			});
		}else{
			new FnTop();
			topNews();
			topNewsSlider();
			fnNews();
			topMainvisualEffect();
			serviceIndex();
			setWrapMargin();
		}
		if($('body')[0].getAttribute('data-category') == 'access'){
			initMap.muromachi();
			initMap.tokyo();
			initMap.jujo();
			initMap.akezu();
		}
		$('.entrance ul li:nth-of-type(2) a').on('click', function(e){
			e.preventDefault();
			$('.entrance').addClass('is--hide');
			sessionStorage.entrance = 'is--hide';
		});
		headerScroll();
		setBtnPageTop();
		formCtr();
		runWoookmark();
		$('.header').removeClass('is--scrolls');
		this.$window.scrollTop(0);

	},
	onClick: function(e,self,n){
		e.preventDefault();

		var that = this;
		var target = $(self).attr('href');
		var page = target.split('.')[0];

		that.onFetch();
		history.pushState(this.pushStateObj(target), page, target);
		setTimeout(function(){
			that.changeCurrent(that.getCategory(),that.getPage());
			that.chageContents(target);
		}, 1000)
		setTimeout(function(){
			that.$window.scrollTop(n);
			new TopMainvisual();
		}, 1100)
	},
	onPopState: function(e){
		var that = this;
		that.onFetch();
		setTimeout(function(){
			that.changeCurrent(that.getCategory(),that.getPage());
			that.$window.scrollTop(0);
			that.chageContents(that.getTarget(e));
		}, 1000)
		setTimeout(function(){
			new TopMainvisual();
		}, 1100)
	},
	onFetch: function(){
		//ページ遷移前の処理
		$('.loading').removeClass('is--hide');
		//$('.wrap').addClass('is--hide');
	},
	changeCurrent: function(category, page){
		$('body')[0].setAttribute('data-category', category);
		if((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') == 'top' || $('body')[0].getAttribute('data-category') == 'access')){
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=device-width, initial-scale=1.0');
		}else if((ua('iphone') || ua('android')) && ($('body')[0].getAttribute('data-category') != 'top' || $('body')[0].getAttribute('data-category') != 'access')){
			$('meta[name="viewport"]')[0].setAttribute('content', 'width=1200, initial-scale=1.0');
		}
		$('body')[0].setAttribute('data-current', 'mainvisual');
		$('body')[0].setAttribute('data-page', category + '__' +page);
		$('.wrap')[0].setAttribute('data-category', category);
		$('.wrap')[0].setAttribute('data-page', category + '__' +page);
		$('.wrap')[0].setAttribute('data-current', 'mainvisual');
		$('.wrap').removeAttr('style');
		if($('.container')[0]){
			$('.container')[0].setAttribute('data-category', category);
			$('.container')[0].setAttribute('data-page', category + '__' +page);
		}
		if($('.snav')[0]){
			$('.snav')[0].setAttribute('data-page', category + '__' +page);
		}
		$('.header')[0].setAttribute('data-category', category);
	},
	chageContents: function(target){
		this.$wrap.load(target + " " + '#wrap--inner', function(a, b, c) {
			//$('.wrap').removeClass('is--hide');
			var t = a.match(/<title>[\s\S]*?<\/title>/i)[0].replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
			document.title = t;

			if(!(ua('iphone') || ua('android'))){
				fnNews();
				new TopMainvisual();
				topNews();
				serviceIndex();
				setWrapMargin();
			}

			if($('.wrap')[0].getAttribute('data-page') != 'service__index'){
				$('body').removeAttr('style');
			}
			if($(window).scrollTop() == 0){
				$('.header').removeClass('is--scroll');
			}
			setTimeout(function(){
				$('.loading').addClass('is--hide');
			},500);
			setTimeout(function(){
				runInview();
			},500);
			if($('body')[0].getAttribute('data-category') == 'access'){
				initMap.muromachi();
				initMap.tokyo();
				initMap.jujo();
				initMap.akezu();
			}
			headerScroll();
			setBtnPageTop();
			formCtr();
			runWoookmark();
			gtag('config', 'UA-118282026-1', {'page_path': location.pathname.slice(1)});
		});
	},
	getCurrentPath: function(){
		return location.pathname;
	},
	pushStateObj: function(target){
		var state = {'target': target};
		return state;
	},
	getTarget: function(e){
		var state = e.originalEvent.state;
		return state.target;
	},
	getCategory: function(){
		var category = this.getCurrentPath().split('/')[1];
		if(category == ''){
			category = 'top';
		}
		return category;
	},
	getPage: function(){
		var page = this.getCurrentPath().split('/')[2];
		if(page == undefined){
			page = 'index';
		}
		return page;
	}
}

module.exports = Pjax;


// WEBPACK FOOTER //
// ./es2015/_pjax.js